import { CharacterAttack } from './CharacterAttack';

export class AttackStarfireSpecialForward extends CharacterAttack {
  trigger() {
    super.trigger();
    this._charging = false;
    this._direction = this._character.faceDirection;
    this._chargeDuration = 0;
    this.attackCollider.enabled = false;
    this._positionTracking = [];
    this._positionUpdate = 0;
  }

  _triggerAttackAnimation() {
    this._character.playAnimation('forward_special_in', false, this._charge, this);
  }

  _charge() {
    this.attackCollider.enabled = true;
    this._character.playAnimation('forward_special_loop', true);
    this._charging = true;
  }

  _endCharge() {
    this.attackCollider.enabled = false;
    this._character.playAnimation('forward_special_out', false, this.completeAttack, this);
  }

  completeAttack() {
    this._character.bodyCollider.enabled = true;
    super.completeAttack();
  }

  updateActive(delta) {
    super.updateActive(delta);

    if (this._charging) {
      this._chargeDuration += delta;
      if (this._chargeDuration > 0.5) {
        this._endCharge();
      } else {
        this._character.velocity.x = this._character.movementSpeed * 3 * this._direction;
        // check if character is stuck
        const dx = Math.abs(this.character.x - this._positionUpdate);
        this._positionUpdate = this.character.x;
        this._positionTracking.push(dx);
        if (this._positionTracking.length > 5) {
          this._positionTracking.shift();
          let dist = 0;
          for (let i = 0; i < this._positionTracking.length - 1; i++) {
            dist += this._positionTracking[i];
          }
          // character has not moved in the last 5 updates, consider it stuck
          if (dist < 1) return this._endCharge();
        }
      }
    }
  }

  updateAttackCollider() {
    const bounds = this._character.getBounds();
    this._character.attackCollider.x = this.character.x + (this._direction > 0 ? 0 : -250);
    this._character.attackCollider.y = this.character.y - 200;
    this._character.attackCollider.width = 250;
    this._character.attackCollider.height = 200;
  }
}
